
{
  "fr": {
    "customerProjectModal": {
      "description": "Votre projet a été enregistré. N'oubliez pas de l'enregistrer à la prochaine modification.",
      "buttons": {
        "account": "Aller dans mon espace",
        "close": "Fermer cette fenêtre"
      }
    }
  }
}
